import engineering from "./engineering";
import utility from "./utility";

const utilities = {
  engineering,
  utility,
};

export default utilities;
